import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function UnkownTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.unknownTasksSelector);
  const count = useSelector(taskRedux.unknownTasksCountSelector);
  const status = useSelector(taskRedux.unknownTasksStatusSelector);
  const page = useSelector(taskRedux.unknownTasksPageSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveUnknownTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveUnknownTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          displayPet={false}
          onRefresh={() => dispatch(taskRedux.actions.retrieveUnknownTasks())}
          loading={status === 'loading'}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default UnkownTable;
